import SSOLoginComponent from "./sso-login.component";

export default SSOLoginComponent;
